export default {
  api_endpoint: process.env.VUE_APP_API_ENDPOINT
    ? process.env.VUE_APP_API_ENDPOINT
    : "https://api.stellenticket.de",
}
